import { UnreachableValueError } from '@vy/err';
import { FEEDBACK_ERROR_CODES } from './feedback-error-codes';

export class JobTaskStatusUnreachableError extends UnreachableValueError {
  constructor(status: never) {
    super(status, FEEDBACK_ERROR_CODES.JOB_TASK_STATUS_UNREACHABLE_ERROR);
  }
}
